import { jsxs as t, jsx as i } from "react/jsx-runtime";
function l(h) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...h,
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#clip0_683_603)", children: [
          /* @__PURE__ */ i("path", { d: "M0.8125 3.47917V17.3908H5.60333V20H8.21917L10.8308 17.39H14.7517L19.98 12.175V0H2.11833L0.8125 3.47917ZM3.86083 1.7375H18.2375V11.3033L15.1875 14.3467H10.395L7.78333 16.9525V14.3467H3.86083V1.7375Z" }),
          /* @__PURE__ */ i("path", { d: "M8.65417 5.21875H10.3958V10.4354H8.65417V5.21875Z" }),
          /* @__PURE__ */ i("path", { d: "M13.4442 5.21875H15.1867V10.4354H13.4442V5.21875Z" })
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_683_603", children: /* @__PURE__ */ i("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
export {
  l as default
};
